import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateUnitPrice(totalPrice: number, quantity: number) {
  if (quantity <= 0 || totalPrice <= 0 || typeof totalPrice !== "number" || typeof quantity !== "number") {
    return 0;
  }

  return Math.round((totalPrice / quantity) * 100) / 100;
}

export function calculateDiscountPercentage(originalPrice: number, discountedPrice: number) {
  if (originalPrice <= 0 || discountedPrice < 0) {
    throw new Error("Prices must be positive values.");
  }

  if (discountedPrice < 1) {
    discountedPrice *= 100;
    originalPrice *= 100;
  }

  const discountAmount = originalPrice - discountedPrice;
  const discountPercentage = (discountAmount / originalPrice) * 100;

  return discountPercentage;
}
